import React from 'react';
import { styled } from '@linaria/react';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Stack } from '@daedalus/atlas/helpers/Stack';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { FacetFilterProps, RenderType } from '.';
const _exp = /*#__PURE__*/() => Flex.Row;
const SkeletonRow = /*#__PURE__*/styled(_exp())({
  name: "SkeletonRow",
  class: "s18q8bgf",
  propsAsIs: true
});
type Props = Pick<FacetFilterProps, 'renderType'>;
export const FacetFilterContentLoader: React.FC<Props> = ({
  renderType
}) => {
  const height = renderType === RenderType.Card ? 80 : 24;
  const rows = renderType === RenderType.Card ? 2 : 4;
  return <ContentWrapper paddingBottom="s600">
      {Array.from({
      length: rows
    }).map((_, index) => <Stack key={index} space="s300">
          <SkeletonRow gap="s200" alignItems="flex-end">
            <SkeletonLoader height={height} />
            <SkeletonLoader height={height} />
          </SkeletonRow>
        </Stack>)}
    </ContentWrapper>;
};

require("./FacetFilterContentLoader.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FacetFilterContentLoader.tsx");